export default {
  /** FOR TABLES - use id from 1 to 1000 (1-2000) */

  //table with seat capacity 1
  TABLE_1_RECT_0DEG: 101,
  TABLE_1_RECT_45DEG: 102,
  TABLE_1_RECT_90DEG: 103,
  TABLE_1_RECT_135DEG: 104,
  TABLE_1_RECT_180DEG: 105,
  TABLE_1_RECT_225DEG: 106,
  TABLE_1_RECT_270DEG: 107,
  TABLE_1_RECT_315DEG: 108,
  TABLE_1_CIRCLE_0DEG: 109,
  TABLE_1_CIRCLE_45DEG: 110,
  TABLE_1_CIRCLE_90DEG: 111,
  TABLE_1_CIRCLE_135DEG: 112,
  TABLE_1_CIRCLE_180DEG: 113,
  TABLE_1_CIRCLE_225DEG: 114,
  TABLE_1_CIRCLE_270DEG: 115,
  TABLE_1_CIRCLE_315DEG: 116,

  //table with seat capacity 2
  TABLE_2_CIRCLE_0DEG: 201,
  TABLE_2_CIRCLE_45DEG: 202,
  TABLE_2_CIRCLE_90DEG: 203,
  TABLE_2_CIRCLE_135DEG: 204,
  TABLE_2_RECT_1_1_0DEG: 205,
  TABLE_2_RECT_1_1_45DEG: 206,
  TABLE_2_RECT_1_1_90DEG: 207,
  TABLE_2_RECT_1_1_135DEG: 208,

  //table with seat capacity 4
  TABLE_4_RECT_1_1_1_1_0DEG: 401,
  TABLE_4_RECT_1_1_1_1_45DEG: 402,
  TABLE_4_RECT_2_2_0DEG: 403,
  TABLE_4_RECT_2_2_45DEG: 404,
  TABLE_4_RECT_2_2_90DEG: 405,
  TABLE_4_RECT_2_2_135DEG: 406,
  TABLE_4_CIRCLE_0DEG: 407,
  TABLE_4_CIRCLE_45DEG: 408,

  //table with seat capacity 6
  TABLE_6_RECT_1_2_1_2_0DEG: 601,
  TABLE_6_RECT_1_2_1_2_45DEG: 602,
  TABLE_6_RECT_1_2_1_2_90DEG: 603,
  TABLE_6_RECT_1_2_1_2_135DEG: 604,
  TABLE_6_RECT_3_3_0DEG: 605,
  TABLE_6_RECT_3_3_45DEG: 606,
  TABLE_6_RECT_3_3_90DEG: 607,
  TABLE_6_RECT_3_3_135DEG: 608,
  TABLE_6_CIRCLE: 609,

  //table with seat capacity 8
  TABLE_8_RECT_2_2_2_2_0DEG: 801,
  TABLE_8_RECT_2_2_2_2_45DEG: 802,
  TABLE_8_RECT_4_4_0DEG: 803,
  TABLE_8_RECT_4_4_45DEG: 804,
  TABLE_8_RECT_4_4_90DEG: 805,
  TABLE_8_RECT_4_4_135DEG: 806,
  TABLE_8_RECT_1_3_1_3_0DEG: 807,
  TABLE_8_RECT_1_3_1_3_45DEG: 808,
  TABLE_8_RECT_1_3_1_3_90DEG: 809,
  TABLE_8_RECT_1_3_1_3_135DEG: 810,
  TABLE_8_CIRCLE: 811,

  //table with seat capacity 10
  TABLE_10_RECT_1_4_1_4_0DEG: 1001,
  TABLE_10_RECT_1_4_1_4_45DEG: 1002,
  TABLE_10_RECT_1_4_1_4_90DEG: 1003,
  TABLE_10_RECT_1_4_1_4_135DEG: 1004,
  TABLE_10_RECT_2_3_2_3_0DEG: 1005,
  TABLE_10_RECT_2_3_2_3_45DEG: 1006,
  TABLE_10_RECT_2_3_2_3_90DEG: 1007,
  TABLE_10_RECT_2_3_2_3_135DEG: 1008,
  TABLE_10_RECT_5_5_0DEG: 1009,
  TABLE_10_RECT_5_5_45DEG: 1010,
  TABLE_10_RECT_5_5_90DEG: 1011,
  TABLE_10_RECT_5_5_135DEG: 1012,
  TABLE_10_CIRCLE: 1013,

  /** FOR OTHER SHAPES - use id from 2001 to 3000 */
  RECTANGLE: 2001,
  SQUARE: 2002,
  CIRCLE: 2003,
  POLYGON: 2004,
  LINE: 2005,

  /** FOR IMAGES - use id from 3001 onwards */
  SOFA_IMG: 3001,
  DOOR_IMG: 3002,
  WINDOW_IMG: 3003,
  AQUARIUM_IMG: 3004,
  PAINTING_IMG: 3005,
  CHAIR_IMG: 3006,
  RESTROOM_IMG: 3007,
  KITCHEN_IMG: 3008,
};
